import { useEffect, useState } from 'react'

type ApiResponse = {
  updated_at: string
  data: {
    [key: string]: {
      name: string
      symbol: string
      price: string
      price_BNB: string
    }
  }
}

const api = 'https://api.pancakeswap.info/api/tokens'

const useGetPriceData = () => {
  const [data, setData] = useState<ApiResponse | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(api)
        const res: ApiResponse = await response.json()
        // console.log("sir please chal paren",res.data['0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'])
        res.data['0xDa3a903d329286AA299F47BC4edfb3F8e2e6F1B0']= res.data['0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82']
        res.data['0x7af326b6351c8a9b8fb8cd205cbe11d4ac5fa836']= res.data['0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c']
        setData(res)
      } catch (error) {
        console.error('Unable to fetch price data:', error)
      }
    }

    fetchData()
  }, [setData])

  return data
}

export default useGetPriceData
